import { options } from "@/global/slick-options";

jQuery( '.big-slider-slider' ).slick( {
    ...options,
    dots: false,
    infinite: true,
    centerMode: true,
    centerPadding: '20%',
    rows: 0,
} );
